import React from 'react';
import { range } from 'lodash';
import PropTypes from 'prop-types';

import * as Ph from '~/App/Components/Placeholder';

function PhSegment({ count = 1 }) {
  return (
    <React.Fragment>
      <Ph.Col size={12}>
        <Ph.Row>
          <Ph.Col size={12} />
        </Ph.Row>
      </Ph.Col>
      {range(count).map((_, i) => (
        <React.Fragment key={i}>
          <Ph.Col size={2}>
            <Ph.Avatar size={40} />
          </Ph.Col>
          <Ph.Col size={9} style={{ paddingTop: 5 }}>
            <Ph.Row>
              <Ph.Col size={12} />
              <Ph.Col size={12} />
            </Ph.Row>
          </Ph.Col>
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

PhSegment.propTypes = {
  count: PropTypes.number,
};

const styles = {
  width: '100%',
  marginLeft: 0,
  padding: 10,
};

export default function Loading() {
  return (
    <Ph.Item style={styles}>
      <PhSegment count={4} />
      <PhSegment count={3} />
      <PhSegment count={5} />
    </Ph.Item>
  );
}
